/* This is a 3rd party JS which generates the lead id to be sent for RCM leads. Please don't remove it */
export const generateLeadIdForRCM = function() {
  if (MOVE_DATA.leadid_token) return;
  var s = document.createElement('script');
  s.id = 'LeadiDscript_campaign';
  s.type = 'text/javascript';
  s.async = true;
  s.src = (document.location.protocol + '//d1tprjo2w7krrh.cloudfront.net/campaign/01836014-7527-fd48-9b7f-1a40a9705cfe.js');
  document.body.appendChild(s);
  watchForTokenToLoad();
}

const watchForTokenToLoad = function() {
  const intervalID = setInterval(function () {
    if (MOVE_DATA.leadid_token) clearInterval(intervalID);
    let $leadToken = $('#leadid_token');
    if ($leadToken && $leadToken.length) {
      MOVE_DATA.leadid_token = $leadToken.val();
    }
  }, 500);

  setTimeout(function() {
    clearInterval(intervalID);
  }, 8000);
}



// WEBPACK FOOTER //
// ./mortgage/jornaya_lead_id.js